import React, { useRef } from "react";
import { Chip } from "@mui/material";
import soundFile from "../Raw/stopped.mp3";

const UserConnectCheck = ({ status }) => {
  const isOnline = Boolean(status);
  const color = isOnline
    ? { color: "#1b5e20", text: "ON" }
    : { color: "#d50000", text: "OFF" };

  return (
    <Chip
      label={
        <div style={{ textAlign: "center" }}>
          <span>{color.text}</span>
        </div>
      }
      style={{
        backgroundColor: color.color,
        color: "white",
        borderRadius: "5px",
        fontWeight: "bold",
        height: "auto",
        padding: "5px",
      }}
    />
  );
};

export default React.memo(UserConnectCheck);
